import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgInfo24 = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("g", {
		fill: "none",
		fillRule: "evenodd",
		children: /* @__PURE__ */ _jsx("g", {
			fill: "#003262",
			children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("path", {
				d: "M14 17h-4c-.552 0-1-.447-1-1 0-.553.448-1 1-1h1v-3h-1c-.552 0-1-.447-1-1 0-.553.448-1 1-1h2c.552 0 1 .447 1 1v4h1c.552 0 1 .447 1 1 0 .553-.448 1-1 1M12 6c.829 0 1.5.672 1.5 1.5S12.829 9 12 9s-1.5-.672-1.5-1.5S11.171 6 12 6m0-4C6.477 2 2 6.478 2 12s4.477 10 10 10 10-4.478 10-10S17.523 2 12 2",
				transform: "translate(-100 -1623) translate(100 1623)"
			}) })
		})
	})]
});
const ForwardRef = forwardRef(SvgInfo24);
export default ForwardRef;
